import React from "react";
import { Chip } from "@/components/Chip";
import { PricingCard } from "@/components/PricingCard";
import { RadioButton } from "@/components/RadioButton";
import { RichTextBlock } from "@/components/RichTextBlock";
import { BenefitsList } from "./BenefitsList";
import { PlanWrapperProps } from "./types";

export const PlanWrapper = ({
  data,
  currentPlan,
  onSelectPlan,
  isStatusActive,
  customClass,
}: PlanWrapperProps) => {

  const plansInfo = data?.prices;
  return (
    <div className={`plan-wrapper ${customClass}`}>
      {plansInfo &&
        plansInfo.map((plan) => (
          <PricingCard
            key={plan.id}
            active={plan.id === currentPlan?.id}
            header={plan.header}
            onClick={onSelectPlan}
            id={plan.id}
            dataQa={plan["data-qa"]}
            customClass={plan.customClass}>
            <div className="plan-box__title">
              <div className="plan-box__name">
                {!isStatusActive && (
                  <RadioButton
                    id={plan.id}
                    name="plan"
                    className="plan-box__title__radio"
                    value={plan.id}
                    checked={plan.id === currentPlan?.id}
                    readOnly={true}
                  />
                )}
                <RichTextBlock item={plan.name.richtext} />

                {plan.name.chip && (
                  <Chip
                    label={plan.name.chip}
                    color={"warning"}
                    type={"filled"}
                    className={"button--chip"}
                    size="medium"
                  />
                )}
              </div>

              <div className="plan-box__price">
                {Array.isArray(plan.price.richtext) ? (
                  plan.price.richtext.map((item, ind) => (
                    <RichTextBlock
                      item={item}
                      key={ind}
                    />
                  ))
                ) : (
                  <RichTextBlock item={plan.price.richtext} />
                )}
              </div>
            </div>
            <div className={plan.benefits.richtext.classname}>
              <BenefitsList
                list={plan?.benefits?.richtext?.list}
                active={plan?.id === currentPlan?.id}
              />
            </div>
          </PricingCard>
        ))}
    </div>
  );
};
